import React from 'react'

const Certificate = () => {
    const hackstack_22 = require('../../assets/certificates/01_HackStack_22_Certificate.pdf');
    const duhacks_2_0 = require('../../assets/certificates/DUHacks2.0_Appreciation.pdf');

    return (
        <div className='container'>
            <div class="section-title">
                <div className="header-text-h1">
                    <h1 className='header-text'>Certificates</h1>
                </div>
                <br />
                <br />
            </div>
            <div className='row'>
                <div className='col-md-6'>
                    <div className='card shadow-lg p-3 mb-5 bg-white rounded page'>
                        <div className='card-body'>
                            <h3 className='card-title'>DUHacks 2.0</h3>
                            <p className='blockquote'>Honored to have been recognized with an appreciation certificate for my contribution as a member of the organizing team for DUHacks 2.0. Collaborating closely with fellow organizers, I played a key role in planning, coordinating, and ensuring the success of the event. Excited to continue contributing to impactful initiatives and fostering innovation in the tech community.</p>
                            <a href={duhacks_2_0} className='btn btn-primary'>View Certificate</a>
                        </div>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='card shadow-lg p-3 mb-5 bg-white rounded page'>
                        <div className='card-body'>
                            <h3 className='card-title'>HackStack'22 Hackathon</h3>
                            <p className='blockquote'>I have participated in HackStack'22, collaborating with a team to develop a RentAround Project and our team got 5th rank out of 80 teams. Excited to leverage this experience to drive innovation and tackle challenges in future projects.</p>
                            <a href={hackstack_22} className='btn btn-primary'>View Certificate</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Certificate
